import { Stack } from '@mui/material';
import { Avatar } from '../../../../../components/Avatar';
import { TableRow, Tooltip } from '@mui/material';
import { graphql } from '../../../../../gql';
import { RelativeTime } from '../../../../../journey/RelativeTime';
import { useApiQuery } from '../../../../../query/hooks';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Switcher } from '../../../../../layout/Switcher';
import ControlCheckTable from '../../../../../components/Table/Table';
import { CustomTableCell } from '../../../../../components/Table/TableCell';

type ControlCheckHistoryTableProps = Readonly<{
	activityId: string;
}>;

const getControlCycleHistory = graphql(`
	query journeyDetail_getControlCycleHistoryQuery($activityId: UUID!) {
		getActivity(by: { id: $activityId }) {
			controlCycle {
				history {
					id
					at
					who {
						id
						avatar {
							url(width: 24, height: 24)
						}
						name
					}
				}
			}
		}
	}
`);

export const ControlCheckHistoryTable: FC<ControlCheckHistoryTableProps> = ({ activityId }) => {
	const { data, isLoading } = useApiQuery(getControlCycleHistory, { variables: { activityId } });

	const headerData = [
		{ text: <FormattedMessage id={'table.control-cycle-history.header.creator'} /> },
		{ text: <FormattedMessage id={'table.control-cycle-history.header.updated'} /> },
	];

	const rows =
		data?.getActivity?.controlCycle?.history.map((historyEntry) => (
			<TableRow key={historyEntry.id} hover>
				<CustomTableCell>
					<Tooltip title={historyEntry.who?.name} arrow>
						<Avatar src={historyEntry.who?.avatar?.url ?? ''} sx={{ width: 24, height: 24 }} />
					</Tooltip>
				</CustomTableCell>
				<CustomTableCell>
					<RelativeTime date={new Date(historyEntry.at)} />
				</CustomTableCell>
			</TableRow>
		)) || [];

	return (
		<Stack width={'100%'} gap={4} mt={2}>
			<Stack width={'fit-content'}>
				<Switcher
					variant={'tabs'}
					config={[
						{
							item: 'CONTROL_CYCLE_HISTORY',
							title: <FormattedMessage id={'table.control-cycle-history.title'} />,
							onNavigate: () => {}, // for now just one item, no navigation needed
							isActive: () => true,
						},
					]}
				/>
			</Stack>
			<Stack mt={3}>
				<ControlCheckTable variant={'withoutTitle'} isLoading={isLoading} headerData={headerData} tableRows={rows} />
			</Stack>
		</Stack>
	);
};
